function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 10.5h12v3H6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 6v12h-3V6z"
}));

function SvgZoomIn(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im02IDEwLjVoMTJ2M2gtMTJ6Ii8+PHBhdGggZD0ibTEzLjUgNmgxMnYzaC0xMnoiIHRyYW5zZm9ybT0ibWF0cml4KDAgMSAtMSAwIDE5LjUgLTcuNSkiLz48L2c+PC9zdmc+Cg==";
export { ForwardRef as ReactComponent };